"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BTTCUpToken = exports.BTTCWrappedToken = exports.BTTCNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.BTTCNativeToken = new utils_1.Currency("BTT", 18, "BTT", "BTT");
exports.BTTCWrappedToken = new utils_1.Currency("0x8D193c6efa90BCFf940A98785d1Ce9D093d3DC8A", 18, "WBTT", "Wrapped BitTorrent");
exports.BTTCUpToken = new utils_1.Currency("0x2220c7cD9946b9c03f0BDBbD24fa4df76E7C63e7", 18, "UP", "UP");
